// extracted by mini-css-extract-plugin
module.exports = {"container":"ShippingPageContent_container__GwBA4"};